import { acquired } from "./acquired";

export const data = {
  acquired
};
